// eslint-disable-next-line
export const LOCALE_KEY = 'locale';

export const SAGA_CONTEXT_KEY = '@ackee/jerome-intl';
